var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { RacingStore } from "../../../data/store";
/*
    Tests describing the structure of the ouput data should be written first.
    It would be better to split the tests into few suits:
    - base tests related to class and instance structure
    - business logic
    - edge cases
*/
export class RacingRegionSwitcherData {
    constructor(provider) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
    }
    get regions() {
        return this.racingStore.regions.filter(
        /* istanbul ignore next */
        x => x.hasEvents);
    }
    setParams(regionId, branchId) {
        this.racingStore.setParams(regionId, branchId);
    }
}
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], RacingRegionSwitcherData.prototype, "regions", null);
//# sourceMappingURL=RacingRegionSwitcherData.js.map